import { SlideCarousel } from '@/components/slides/SlideCarousel'

export function MainDashboard() {
  return (
    <div className="flex h-full w-full flex-col py-1">
      <SlideCarousel />
    </div>
  )
}
